const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')
const levelsOfCare = require('../levels-of-care')
const { uploadSchema: s3UploadSchema } = require('./s3-schema')

const shape = labelify({
  mobileUser: yup.mixed(),
  profile: yup.mixed(),
  levelOfCare: yup.string().oneOf(levelsOfCare).nullable().default(''),
  type: yup.string().oneOf(['visit', 'behavior']).default('visit'),
  visit: yup.mixed(),
  behavior: yup.object().shape({
    observed: yup.string().ensure().default('').label('Behavior observed'),
    triggers: yup.array().of(yup.string()).default([]).label('Context / trigger'),
    interventions: yup.array().of(yup.string()).default([]).label('Intervention'),
    outcome: yup.string().ensure().default('').label('Outcome'),
    mood: yup
      .number()
      .nullable()
      .default(null)
      .transform((curr, orig) => (orig === '' ? null : curr))
      .label('Mood after'),
    flagged: yup.boolean().default(false),
  }),
  duration: yup.number().min(5).max(60),
  note: yup.string().nullable(),
  images: yup.array().of(s3UploadSchema).default([]),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const oneToOneActivitySchemaPartial = yup.object().shape(shape)
const oneToOneActivitySchema = oneToOneActivitySchemaPartial.shape(requiredFields(['profile', 'type'])(shape))

module.exports = { oneToOneActivitySchema, oneToOneActivitySchemaPartial }
